export default __webpack_public_path__ + "static/mobileIphoneXR-905b12153a0648b98afb0b3429655e3c.jpg";